import * as fetch from './Fetch.js'
export default fetch



// WEBPACK FOOTER //
// ./src/common/fetch/index.js